import { PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';

/**
 * Microsoft Entra ID (Azure AD) client. Sign-in is performed directly by the
 * SPA via the authorization-code + PKCE flow; the resulting ID token is sent to
 * the API as a Bearer credential. Tokens are cached in localStorage so silent
 * renewal survives reloads.
 */
export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.msal.clientId,
    authority: environment.msal.authority,
    redirectUri: environment.msal.redirectUri,
    postLogoutRedirectUri: environment.msal.redirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
});

export const LOGIN_SCOPES = ['openid', 'profile', 'email'];

/**
 * Acquire a fresh ID token for the active account, renewing silently when
 * needed. Returns undefined when there is no signed-in account.
 */
export async function acquireIdToken(): Promise<string | undefined> {
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  if (!account) {
    return undefined;
  }

  try {
    const result = await msalInstance.acquireTokenSilent({ scopes: LOGIN_SCOPES, account });
    return result.idToken;
  } catch {
    return undefined;
  }
}
